import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { NewsCategory } from '@/types';
import { newsCategoryApi } from '@/api/newsCategory';
import { useActionFeedback } from '@/hooks/useActionFeedback';

export const useNewsCategoryList = (params: { page?: number; limit?: number; active?: boolean } = {}) =>
  useQuery({
    queryKey: ['news-categories', params],
    queryFn: () => newsCategoryApi.getAll(params),
  });

export const useCreateNewsCategory = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: (data: Partial<NewsCategory>) => newsCategoryApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['news-categories'] });
      feedback.success('Kategori berita berhasil dibuat');
    },
    onError: (error) => {
      feedback.error('Gagal membuat kategori berita', error);
    },
  });
};

export const useUpdateNewsCategory = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: Partial<NewsCategory> }) => newsCategoryApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['news-categories'] });
      feedback.success('Kategori berita berhasil diperbarui');
    },
    onError: (error) => {
      feedback.error('Gagal memperbarui kategori berita', error);
    },
  });
};

export const useDeleteNewsCategory = () => {
  const queryClient = useQueryClient();
  const feedback = useActionFeedback();

  return useMutation({
    mutationFn: (id: number) => newsCategoryApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['news-categories'] });
      feedback.success('Kategori berita berhasil dihapus');
    },
    onError: (error) => {
      feedback.error('Gagal menghapus kategori berita', error);
    },
  });
};
